import styled from "@emotion/styled";
import { SelectChangeEvent } from "@mui/material";
import { ChangeEvent, FormEvent, useState } from "react";
import Calendars from "../../components/calendars";
import SelectBox from "../../components/selectBox";
import theme from "../../theme";
import { FetchParams } from "./detectList";
import { getEventOptions, getMobileOptions } from "../../utils/constants";
import { SearchForm } from "../../components/common/SearchForm";
import { FileDownloadIcon } from "../../assets/icons/icons";
import userStorage from "../../utils/userStorage";
import { useI18n } from "../../locales";
import { Button } from "../../components/common/Button";
//import { SelectBoxGroupId } from "../../components/SelectBoxGroupId";

interface SubHeaderProps {
  onClickBtn: ({
    startDate,
    endDate,
    searchKey,
    detFilter,
    mobFilter,
  }: FetchParams) => void;
  onClickDown?: () => void;
  downIsPending?: boolean;
}

// 파일 다운로드 기능을 사용할 수 있는 유저 조건
// const DOWNLOADABLE_GOV_IDS = ["00000", "47130"];
const DOWNLOADABLE_GOV_IDS = [""];

const SubHeader: React.FC<SubHeaderProps> = (props) => {
  const { t } = useI18n();
  const { onClickBtn, onClickDown, downIsPending } = props;
  const user = userStorage.get();
  const [mobFilterOpen, setMobFilterOpen] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [input, setInput] = useState("");
  const [mobFilter, setMobFilter] = useState(-1); // 가짜
  const [detFilter, setDetFilter] = useState(0); // 진짜
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const isDownloadableUser = DOWNLOADABLE_GOV_IDS.some((el) =>
    user?.gov_id.includes(el)
  ); // 농콜 리포트 엑셀파일 다운로드 기능 사용 가능한지 여부
  const [groupSub/*, setGroupSub*/] = useState("all"); // 하위그룹코드(화면용)

  const handleChange = (event: SelectChangeEvent) => {
    setDetFilter(Number(event.target.value));
  };

  const handleClose = () => {
    setFilterOpen(false);
  };

  const handleOpen = () => {
    setFilterOpen(true);
  };

  const mobHandleChange = (event: SelectChangeEvent) => {
    setMobFilter(Number(event.target.value));
  };

  const mobHandleClose = () => {
    setMobFilterOpen(false);
  };

  const mobHandleOpen = () => {
    setMobFilterOpen(true);
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInput(event.currentTarget.value);
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onClickBtn({
      startDate,
      endDate,
      mobFilter,
      detFilter,
      searchKey: input,
      groupId: groupSub,
    });
  };

  return (
    <Wrapper>
      <Calendars
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        isSeparate={false}
        gap="20px"
        width={160}
      ></Calendars>
      <BoxWrapper>
        <SelectBox
          open={mobFilterOpen}
          filter={mobFilter}
          handleChange={mobHandleChange}
          handleClose={mobHandleClose}
          handleOpen={mobHandleOpen}
          title={t.history.selectDeviceType}
          menuItems={getMobileOptions(t)}
          width={175}
          srLabel={t.history.selectDeviceType}
        />
        <SelectBox
          open={filterOpen}
          handleChange={handleChange}
          handleOpen={handleOpen}
          handleClose={handleClose}
          filter={detFilter}
          menuItems={getEventOptions(t)}
          title={t.history.selectDetectionType}
          width={175}
          srLabel={t.history.selectDetectionType}
        />
      </BoxWrapper>
      <SearchForm
        onSubmit={onSubmit}
        placeholder={t.history.searchDeviceOwner}
        onChange={onChange}
        inputValue={input}
        setInputValue={setInput}
      />

      {/* 파일 다운로드 버튼 */}
      {isDownloadableUser && (
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            marginTop: "15px",
          }}
        >
          <Button
            bgColor={theme.color.aquamarine_500}
            hoverColor={theme.color.aquamarine_600}
            onClick={onClickDown}
            disabled={downIsPending}
            height="40px"
          >
            <FileDownloadIcon
              width="32px"
              height="32px"
              color={theme.color.white}
            />
            {t.statistics.download}
          </Button>
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 92px;
  background: ${theme.color.neutral_50};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  margin-bottom: 23px;
  gap: 20px;
`;

// const FileDownloadButton = styled.button`
//   border: none;
//   background-color: transparent;
//   cursor: pointer;
//   z-index: 2;
//   margin-left: auto; /* 마지막 요소를 오른쪽으로 밀기 */
//   margin-right: 20px;
//   padding: 0;
//   padding-top: 20px;
//   &:hover {
//     svg {
//       fill: ${theme.color.green_600};
//     }
//   }
//   &:disabled {
//     svg {
//       fill: ${theme.statusColor.DISABLED};
//       cursor: default;
//     }
//   }
// `;

/*const AddMobileButtonContainer = styled.div`
  margin-top: 3px;
`;*/

const BoxWrapper = styled.div`
  margin-left: 30px;
`;


export default SubHeader;
